module.exports = __webpack_public_path__ + "static/field_trip_img2@2x-609f3ba10f5e6a678c889dbc4f91d4c5.jpg";